module.exports = __webpack_public_path__ + "img/arrow-right.7f281b10.svg";